import React from "react";

const EMEAGlobalContext = React.createContext({});

export const useEMEAGlobalContext = () => React.useContext(EMEAGlobalContext);

export default EMEAGlobalContext;